export default __webpack_public_path__ + "static/media/miguel-lopes-22.6b59a6b7.jpg";